import { Injectable } from '@angular/core';
import { docData, Firestore } from '@angular/fire/firestore';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { doc } from 'firebase/firestore';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { UpdateAppPage } from '../../public/update-app/update-app.page';
import { MantenimientoScreanPage } from '../components/mantenimiento-screan/mantenimiento-screan.page';
import { GTMEventsCrash } from '../enums/Crashlytics';
import { AppUpdateConfig, IMaintenanceScreen } from '../models/AppUpdateConfig';
import { CrashlyticsService } from './crashlytics/crashlytics.service';
import { FirebaseService } from './firebase.service';

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {

  private firestore: Firestore;
  private modalUpdate: HTMLIonModalElement | null = null;
  private modalMaintenanceScreen: HTMLIonModalElement | null = null;

  constructor(
    private modal: ModalController
    , private firebaseS: FirebaseService
    , private crashlytics: CrashlyticsService
  ) {
    this.firestore = this.firebaseS.firestore as Firestore;
  }

  private getMaintenanceScreen = () => {
    const ref = doc(this.firestore, 'configuraciones/Mantenimiento');
    docData<any, any>(ref)
      .pipe(catchError(async error => await this.crashlytics.sendCrashPlatform(GTMEventsCrash.maintenanceCollect, error)))
      .subscribe(this.callbackSuccessMaintenanceScreen);
  }

  private callbackSuccessMaintenanceScreen = async (success: IMaintenanceScreen) => {
    await this.dismisMaintenanceScreen();
    if (success && success.Activo) {
      await this.openModalMaintenanceScreen(success);
    } else {
      await this.dismisMaintenanceScreen();
    }
  }


  private async openModalMaintenanceScreen(remoteConfigValues: IMaintenanceScreen) {
    this.modalMaintenanceScreen = await this.modal.create({
      component: MantenimientoScreanPage
      , cssClass: 'ion-modal-overlayPage'
      , mode: 'md'
      , backdropDismiss: false
      , componentProps: {
        remoteConfigValues
      }
    })

    return await this.modalMaintenanceScreen.present();
  }

  private async dismisMaintenanceScreen() {
    if (this.modalMaintenanceScreen !== null) {
      await this.modalMaintenanceScreen.dismiss();
    }
  }

  /**
   * Obtiene los datos de configuracion de actualización de version desde FireStone
   */
  private appUpdateFireStone = () => {
    const ref = doc(this.firestore, 'configuraciones/AppUpdate');
    docData<any, any>(ref)
      .pipe(
        catchError(error => {
          this.crashlytics.sendCrashPlatform(GTMEventsCrash.updateCollect, error).then(() => { });
          return of(null);
        })
      )
      .subscribe(this.callbackSuccessAppUpdate);
  }

  private callbackSuccessAppUpdate = async (dataUpdate: AppUpdateConfig) => {
    await this.dismissModalUpdate();
    if (dataUpdate) {
      const versionCode = environment.versionCode;
      if (versionCode < (dataUpdate.VersionCode || 0) || typeof this.modalUpdate !== 'object') await this.openModal(dataUpdate);
    }
  }

  /**
   * Muestra la pantalla de actualización de version forzada
   */
  private async openModal(remoteConfigValues: AppUpdateConfig) {
    this.modalUpdate = await this.modal.create({
      component: UpdateAppPage
      , mode: 'md'
      , backdropDismiss: false
      , componentProps: {
        remoteConfigValues
      }
    })

    return await this.modalUpdate.present();
  }

  private dismissModalUpdate = async () => {
    if (this.modalUpdate !== null) {
      await this.modalUpdate.dismiss();
    }
  }

  public appUpdate() {
    if (Capacitor.isNativePlatform()) {
      this.appUpdateFireStone()
    }

    this.getMaintenanceScreen()
  }
}
